var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 8.75,
    width: 40.5,
    height: 24.5,
    rx: 2.66667,
    stroke: "#FFB72B",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.0498,
    y: 13,
    width: 39.9,
    height: 5,
    fill: "#FFB72B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.12207,
    y: 26.2939,
    width: 10.2439,
    height: 1.92652,
    rx: 0.96326,
    fill: "#FFB72B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.439,
    y: 26.2939,
    width: 5.12195,
    height: 1.92652,
    rx: 0.96326,
    fill: "#FFB72B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.7075,
    y: 24.3672,
    width: 8.19512,
    height: 5.77956,
    rx: 1.36667,
    fill: "#FFB72B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCardIcon);
export default __webpack_public_path__ + "static/media/paymentCardIcon.d5b80486bdcb0a05e154421845260b7c.svg";
export { ForwardRef as ReactComponent };